import { render, staticRenderFns } from "./LastVisited.vue?vue&type=template&id=2af6cdb6&"
import script from "./LastVisited.vue?vue&type=script&lang=js&"
export * from "./LastVisited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports